// @core/api/endpoints/tenant/get_tenant_sso_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantSSOConfigResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Get tenant SSO configuration
 * Returns the current SSO/IdP configuration for the tenant including SAML or OIDC settings, provisioning rules, and connection status.
 */
export async function GetTenantSSOConfig(
  tenant_id: string,
  options?: RequestOptions
): Promise<TenantSSOConfigResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/sso`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.get<TenantSSOConfigResponse>(requestPath, { ...requestOptions });
}
